"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useEventCallback = void 0;

var _react = require("react");

var _useIsomorphicLayoutEffect = _interopRequireDefault(require("react-use/lib/useIsomorphicLayoutEffect"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 返回一个在每次渲染中都有相同引用的回调函数并且始终能访问到最新的 `props` 和 `state`，类似 class 组件中的成员方法。
 * 用于解决但不限于下列问题：
 * 1. 传递给自定义组件的回调函数触发时绑定的 `props` 和 `state` 可能过时
 * 2. 频繁更新引用的回调函数触发自定义组件中昂贵的计算或者是意外执行 effect
 * 未来 React 可能会用更好的方案实现类似的功能，参考：https://github.com/facebook/react/issues/14099
 *
 * @example
 * ```tsx
 * const Form = () => {
 *   const [text, updateText] = useState('')
 *   const handleSubmit = useEventCallback(() => {
 *     alert(text)
 *   })
 *   return (
 *     <>
 *       <input value={text} onChange={e => updateText(e.target.value)} />
 *       <ExpensiveComponent onSubmit={handleSubmit} />
 *     </>
 *   )
 * }
 * ```
 * @param fn
 * @param deps
 */
var useEventCallback = function useEventCallback(fn, deps) {
  var ref = (0, _react.useRef)(fn);
  (0, _useIsomorphicLayoutEffect.default)(function () {
    ref.current = fn;
  }, deps);
  return (0, _react.useCallback)(function () {
    return ref.current.apply(ref, arguments);
  }, []);
};

exports.useEventCallback = useEventCallback;